import { render, staticRenderFns } from "./CombinationsStepInfo.vue?vue&type=template&id=44d5035a&scoped=true"
import script from "./CombinationsStepInfo.vue?vue&type=script&lang=ts"
export * from "./CombinationsStepInfo.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsStepInfo.vue?vue&type=style&index=0&id=44d5035a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5035a",
  null
  
)

export default component.exports